import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import { initialize } from 'launchdarkly-js-client-sdk';
import type { LDEvaluationDetail, LDLogger } from 'launchdarkly-js-client-sdk';
import type { IsomorphicBindings } from 'src/types/bindings';

function createLaunchDarklyLogger(logger: IsomorphicBindings['Logger']): LDLogger {
    const ldLogger = logger.getSubLogger({ name: 'LaunchDarkly' });

    return {
        debug: (message: string) => {
            // LaunchDarkly debug logs are very verbose, so only log them if TRACE is enabled
            if (TRACE) {
                ldLogger.trace(message);
            }
        },
        info: (message: string) => {
            ldLogger.info(message);
        },
        warn: (message: string) => {
            ldLogger.warn(message);
        },
        error: (message: string) => {
            ldLogger.error(message);
        },
    };
}

export const launchDarklyBrowserModule = new TypedContainerModule<IsomorphicBindings>((bind) => {
    bind('LaunchDarklyClient').toDynamicValue((ctx) => {
        const configService = ctx.container.get('ConfigService');
        const datadogModule = ctx.container.get('DatadogService');
        const logger = ctx.container.get('Logger');
        const launchDarklyBrowserClient = initialize(
            configService.launchDarklyConfig.clientSideId,
            {
                kind: 'user',
                key: 'anonymous',
            },
            {
                logger: createLaunchDarklyLogger(logger),
                inspectors: [
                    {
                        type: 'flag-used',
                        name: 'dd-inspector',
                        method: (key: string, detail: LDEvaluationDetail) => {
                            datadogModule.addFeatureFlagEvaluation(key, detail.value);
                        },
                    },
                ],
            },
        );

        return launchDarklyBrowserClient;
    });
});
